import React from 'react'
import PropTypes from 'prop-types'
import Modal from './modal'
import { useCommunity } from 'utils'
import { get } from 'lodash'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  supportEmail: PropTypes.string.isRequired,
}

function PendingApprovalAccountModal({ supportEmail, onClose }) {
  const community = useCommunity()
  const content = get(community, 'pendingApprovalModal', {
    title: 'Your Account Is Under Review',
    body: `<div><p>Thanks for creating your account! Please note, your profile will not appear on the map until it has been approved by our team.</p><p>While you wait, we encourage you to complete your profile so everything is ready to go. You’ll receive an email notification as soon as your account is approved and visible on the map.</p><p>If you have any questions, please contact our support team at ${supportEmail}.</p></div>`,
  })
  return (
    <Modal onClose={onClose} className="show-flash modal--pending-approval">
      <h2>{content.title}</h2>
      <div
        className="modal-content pending-approval-account-modal"
        dangerouslySetInnerHTML={{ __html: content.body }}
      />
    </Modal>
  )
}

PendingApprovalAccountModal.propTypes = propTypes
export default PendingApprovalAccountModal
